import React from "react";
import clsx from "clsx";

import Dropdown from "../../../atoms/Dropdown";
import TeacherHeader from "../../../organisms/teacher/TeacherHeader";
import { API_URL } from "../../../teacherStore";
import {
  IBreadcrumbsLink,
  ISimpleTeachingMaterialLesson,
} from "../../../state";
import DownloadButton from "../../../atoms/DownloadButton";
import ModalConfirm from "../../../molecules/ModalConfirm";
import useDebounceCallback from "../../../hooks/useDebounceCallback";

import styles from "./DownloadLeafPdf.module.scss";

export type Props = {
  calling: boolean;
  pdfToken: string | null;
  lessons: ISimpleTeachingMaterialLesson[];
  links: IBreadcrumbsLink[];
  class_id: number;
  goBack: () => void;
  onDownloadPDF: () => void;
  onClearPDFToken: () => void;
};

export const DownloadLeafPdf: React.FC<Props> = ({
  calling,
  pdfToken,
  lessons,
  links,
  class_id,
  goBack,
  onDownloadPDF,
  onClearPDFToken,
}) => {
  const [
    selectedLesson,
    setSelectedLesson,
  ] = React.useState<ISimpleTeachingMaterialLesson>(lessons[0]);
  const [debounced] = useDebounceCallback(() => onDownloadPDF());

  return (
    <>
      <TeacherHeader links={links} />
      <div className={styles.DownloadLeafPdf}>
        <div className={styles.btnBack} onClick={goBack}>
          くクラス選択に戻る
        </div>
        <Dropdown
          className={clsx(styles.dropdown, styles.dropTeachingMaterial)}
          options={lessons.map(lesson => ({
            value: lesson.id,
            label: `${lesson.name} ${lesson.title}`,
          }))}
          onChange={(value: number) =>
            setSelectedLesson(lessons.filter(lesson => lesson.id === value)[0])
          }
        />
        <DownloadButton
          className="ms-auto"
          disabled={calling || !lessons.length}
          onClick={debounced}
        >
          ダウンロード
        </DownloadButton>
      </div>
      {pdfToken && (
        <ModalConfirm
          onClose={onClearPDFToken}
          title="ダウンロードしますか？"
          buttons={[
            {
              title: "キャンセル",
              action: onClearPDFToken,
              type: "None",
            },
            {
              title: "ダウンロード",
              action: () => {
                window.open(
                  `${API_URL}/lessons/${selectedLesson.id}/leaf_pdf?klass_id=${class_id}&temporary_token=${pdfToken}`,
                  "_blank",
                );
                onClearPDFToken();
              },
              type: "Success",
            },
          ]}
        />
      )}
    </>
  );
};

export default DownloadLeafPdf;
